// extracted by mini-css-extract-plugin
module.exports = {"item_main":"style_item_main__1Qeqo"};